import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

export const search = (props) => {
  return <SearchRoundedIcon {...props} />;
};
